export default __webpack_public_path__ + "static/product3-14404a3eac8add362ccc86aac3a095b4.jpg";